// import './App.css';
// import UserForm from './Form';

// function App() {
//   return (
//     <div className="App">
//       <UserForm />
//     </div>
//   );
// }

// export default App;

import { createBrowserRouter } from "react-router-dom";
import "./App.css";
import UserForm from "./Form";
import AdminDashboard from "./Admin/dashboard";
import AdminLayout from "./Admin/Drawer";
import DataTable from "./Admin/Settings";
import UserList from "./Admin/userList";
import Redownload from "./Admin/Redownload";
import VipForm from "./VipForm";
import VipUsers from "./Admin/VipEvents";
import VipEvents from "./Admin/VipEvents";
import ScannerList from "./Admin/Scanner";
import VIPScanner from "./Admin/VIPScanner";
import UniqueGatepass from "./UniqueGate";
import UniqueEvents from "./Admin/UniqueEvents";
import NewUserList from "./Admin/NewUserList";
import SignInForm from "./Admin/SignInForm";
import Home from "./pages/Home";
import AboutKSM from "./pages/AboutKSM";
import AboutKhasdarMahotsav from "./pages/AboutKhasdarMahotsav";
import ContentManage from "./Admin/ContentManage";
import TermsAndConditionsPage from "./Admin/TermCondition";
import PrivacyPolicy from "./Admin/PrivacyPolicy";
import ContactUs from "./Admin/ContactUs";
import FAQDisplay from "./Admin/FAQ";
import VipReg from "./VipReg";
import VIPUsersList from "./Admin/VIPUsersList";
import MediaScanner from "./Admin/MediaScanner";
import ScanComponent from "./Admin/ScreenScanner";
import UserScanner from "./Admin/UserScanner";
import ReferralCodeManagement from "./Admin/ReferralCodeManagement ";

const router = createBrowserRouter([
  // {
  //   path: "/",
  //   element: (
  //     <div className="App">
  //       <UserForm />
  //     </div>
  //   ),
  // },
  {
    path: "/:id",
    element: (
      <div className="App">
        <UserForm />
      </div>
    ),
  },
  // {
  //   path: "/unique/gate/23-12-24/:id",
  //   element: (
  //     <div className="App">
  //       <UniqueGatepass />
  //     </div>
  //   ),
  // },
  {
    path: "/registrations",
    element: (
      <div className="App">
        <UniqueGatepass />
      </div>
    ),
  },
  {
    path: "/registration/2025/:id",
    element: (
      <div className="App">
        <VipReg />
      </div>
    ),
  },
  {
    path: "/unique/settings",
    element: (
      <div className="App">
        <UniqueEvents />
      </div>
    ),
  },

  // {
  //   path: "/vip/parking",
  //   element: (
  //     <div className="App">
  //       <VipForm />
  //     </div>
  //   ),
  // },
  
  {
    path: "/media_scanner",
    element: (
      <div className="App">
        <MediaScanner />
      </div>
    ),
  },
  {
    path: "/scanner",
    element: (
      <div className="App">
        <ScannerList />
      </div>
    ),
  },
  {
    path: "/vip/camera/scanner",
    element: (
      <div className="App">
        <VIPScanner />
      </div>
    ),
  },
  {
    path: "/vipEvents",
    element: (
      // <AdminLayout>
      <div className="App">
        <VipEvents />
      </div>
      // </AdminLayout>
    ),
  },
  {
    path: "/admin/login",
    element: (
      <div className="App">
        <SignInForm />
      </div>
    ),
  },
  {
    path: "/admin/dash",
    element: (
      <AdminLayout>
        <div className="App">
          <AdminDashboard />
        </div>
      </AdminLayout>
    ),
  },
  {
    path: "/settings",
    element: (
      // <AdminLayout>
      <div className="App">
        <DataTable />
      </div>
      // </AdminLayout>
    ),
  },
  {
    path: "/userList",
    element: (
      <div className="App">
        <UserList />
      </div>
    ),
  },
  {
    path: "/unique/userList",
    element: (
      <div className="App">
        <NewUserList />
      </div>
    ),
  },
  {
    path: "/redownload",
    element: (
      <div className="App">
        <Redownload />
      </div>
    ),
  },
  {
    path: "/",
    element: (
      <div className="App">
        <Home />
      </div>
    ),
  },
  {
    path: "/about-ksm",
    element: (
      <div className="App">
        <AboutKSM />
      </div>
    ),
  },
  {
    path: "/about-khasdar-mahotsav",
    element: (
      <div className="App">
        <AboutKhasdarMahotsav />
      </div>
    ),
  },
  {
    path: "/contentManage",
    element: (
      <AdminLayout>
        <div className="App">
          <ContentManage />
        </div>
      </AdminLayout>
    ),
  },

  {
    path: "/terms",
    element: (
      <div className="App">
        <TermsAndConditionsPage />
      </div>
    ),
  },
  {
    path: "/privacy-policy",
    element: (
      <div className="App">
        <PrivacyPolicy />
      </div>
    ),
  },
  {
    path: "/faq",
    element: (
      <div className="App">
        <FAQDisplay />
      </div>
    )
  },
  {
    path: "/contact",
    element: (
      <div className="App">
        <ContactUs />
      </div>
    )
  },
   {
    path: "/vipUserList",
    element: (
      <div className="App">
        <VIPUsersList />
      </div>
    )
  },
  {
    path: "/user/scanner",
    element: (
      <div className="App">
        <UserScanner />
      </div>
    )
  }

,
  {
    path: "/vip/screen/scanner",
    element: (
      <div className="App">
        <ScanComponent />
      </div>
    )
  },

 {
    path: "/referral/code",
    element: (
      <div className="App">
        <ReferralCodeManagement />
      </div>
    )
  },

]);

export default router;
